function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M48 38.79V9.22c0-3.27-2.92-5.47-6.01-5.47H26.3a2.1 2.1 0 000 4.2H42c1.26 0 1.8.86 1.8 1.27v29.57c0 .44-.5 1.25-1.8 1.25H26.3a2.1 2.1 0 000 4.2H42c3.04 0 6-2.15 6-5.45zM16.89 36.8v-6.4H31.8c1.5 0 2.71-1.22 2.71-2.71v-7.4c0-1.49-1.21-2.7-2.7-2.7H16.88v-6.42c0-3.07-1.76-3.79-3.9-1.6L2.74 20.02l-.01.01L.8 22a2.87 2.87 0 000 4.01l1.92 1.95.02.02 4.72 4.82 1.77 1.8 3.75 3.81c2.14 2.2 3.9 1.48 3.9-1.59z"
})));